export const formValues = {
  Title: 'Noticia CCE',
  PosterURL: "https://hoppia.s3-us-west-2.amazonaws.com/events/2020/09/event_hoppia.jpg",
  Text: 'Sin texto',
  URL: 'https://hoppia.s3-us-west-2.amazonaws.com/events/2020/09/event_hoppia.jpg',
  Show: false,
  Date: "2020-09-03T18:00",
}